import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { Button } from "../../../../../../../../components/Button";
import { TextField } from "../../../../../../../../components/TextField";
import { ModalTitle } from "../../../../../../../Settings/components/SecurityModal/SecurityModal.styles";
import {
  AddLinkModalContainer,
  CancelButton,
  NoteSection,
  SubmitContainer,
  textFieldCss,
  URLContainer,
} from "./AddLinkModal.styles";

interface IAddLinkModalProps {
  onClose: (url?: string) => void;
}

export function AddLinkModal({ onClose }: IAddLinkModalProps) {
  const { t } = useTranslation();

  const handleOnSubmitForm = (values: any) => {
    onClose(values.url);
  };

  const formValidationSchema = yup.object().shape({
    url: yup
      .string()
      .url(t("careInfo_addLink_urlInvalid"))
      .required(t("careInfo_addLink_urlRequired")),
  });

  const formik = useFormik({
    initialValues: {
      url: undefined,
    },
    onSubmit: handleOnSubmitForm,
    validationSchema: formValidationSchema,
  });

  return (
    <AddLinkModalContainer>
      <ModalTitle style={{ width: "fit-content" }}>
        {t("careInfo_addLink_title")}
      </ModalTitle>

      <URLContainer>
        <TextField
          label={t("careInfo_addLink_label")}
          name="url"
          placeholder={t("careInfo_addLink_placeholder")}
          backgroudColor="white"
          className={textFieldCss()}
          onChange={formik.handleChange}
          errorMessage={formik.touched.url ? formik.errors.url ?? "" : ""}
        />
      </URLContainer>

      <NoteSection>
        <p style={{ fontWeight: 500 }}>{t("careInfo_addLink_noteTitle")}</p>
        <p>{t("careInfo_addLink_noteBody")}</p>
      </NoteSection>

      <SubmitContainer>
        <Button
          label={t("careInfo_addLink_confirm")}
          type="button"
          onClick={formik.handleSubmit}
        />
        <CancelButton onClick={() => onClose()}>
          {t("common_cancel")}
        </CancelButton>
      </SubmitContainer>
    </AddLinkModalContainer>
  );
}
